import React from 'react';
import { FiFacebook, FiInstagram } from 'react-icons/fi';
import { FaXTwitter } from "react-icons/fa6";
import {Reservation } from '../../Components';
import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer section__padding" id="login" data-aos="fade-up">
      <Reservation />

      <div className="app__footer-links">
        <div className="app__footer-links_contact" data-aos="fade-right">
          <h1 className="app__footer-headtext">Contact Us</h1>
          <p className="p__opensans">123 Grand Avenue, Central City, NY 10001</p>
          <p className="p__opensans">+1 234-567-8910</p>
          <p className="p__opensans">+1 234-567-8910</p>
        </div>

        <div className="app__footer-links_logo" data-aos="zoom-in">
          <img src={images.giovani} alt="footer_logo" />
          <p className="p__opensans">Indulge in Culinary Artistry.</p>
          <br />
          <div className="app__footer-links_icons">
            <FiFacebook />
            <FaXTwitter />
            <FiInstagram />
          </div>
        </div>

        <div className="app__footer-links_work" data-aos="fade-left">
          <h1 className="app__footer-headtext">Opening Hours</h1>
          <p className="p__opensans">Monday-Thursday:</p>
          <p className="p__opensans">11:00 am - 11:00 pm</p>
          <p className="p__opensans">Friday-Sunday:</p>
          <p className="p__opensans">11:00 am - 12:00 pm</p>
        </div>
      </div>

      <div className="footer__copyright" data-aos="fade-up">
        <p className="p__opensans">2024 Giovani. All Rights reserved.</p>
      </div>
    </div>
  );

export default Footer;